import api from "../api";
import { IDevicesParams } from "./interface";

const baseApi = "/UserCustomerPreferences";

export const customerPreferencesService = {
  add: async (params: IDevicesParams) => {
    try {
      const { data } = await api.post(`${baseApi}/v1/Add`, params);
      return {
        success: true,
        message: "",
        body: data.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message,
        body: null,
      };
    }
  },
  put: async (params: IDevicesParams) => {
    try {
      const { data } = await api.put(`${baseApi}/v1/Update`, params);
      return {
        success: true,
        message: "",
        body: data.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message,
        body: null,
      };
    }
  },
  GetByUserId: async (userId: string | number) => {
    try {
      const { data } = await api.get(`${baseApi}/v1/GetByUserId?userId=${userId}`);
      return {
        success: true,
        message: "",
        body: data.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message,
        body: null,
      };
    }
  },
};
